import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import {sequenceCardSchema} from '../../../../schemas/sequenceCardSchema';
import addOrUpdateCardTool from '../../../../tools/general/addOrUpdateCardTool/addOrUpdateCardTool';

export default function addOrUpdateSequenceCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.SEQUENCE,
    cardSchema: sequenceCardSchema,
  });
}
